import React, { useMemo } from "react";
import ReactEcharts from "echarts-for-react";
import "./index.less";

function ScatterData(props) {
  const { data: initialData = {} } = props;
  console.log(initialData, "散点图数据");

  const { metric_fields = [], data: dData = [], dim_field = {} } = initialData;

  // 数值转换工具：兼容数字 / 百分比字符串
  const toNumber = (val) => {
    if (typeof val === "number") return val;
    if (typeof val === "string") {
      const v = val.replace("%", "") * 1;
      return isNaN(v) ? 0 : v;
    }
    return 0;
  };

  // 维度值转数字（用于坐标轴），失败则用索引
  const dimToNumber = (val, index) => {
    if (typeof val === "number") return val;
    if (typeof val === "string") {
      const v = val.replace(/[, %]/g, "") * 1;
      if (!isNaN(v) && val.trim() !== "") return v;
    }
    return index;
  };

  // 构造散点数据
  // - 2 个及以上指标：metric[0] 为 X，metric[1] 为 Y，metric[2]（如有）为气泡大小
  // - 1 个指标：维度值为 X，metric[0] 为 Y
  const { scatterData, hasBubbleSize } = useMemo(() => {
    const rows = dData || [];
    const metrics = metric_fields || [];

    let data;
    if (metrics.length >= 2) {
      data = rows.map((row, idx) => {
        const x = toNumber(row[1]);
        const y = toNumber(row[2]);
        const size = metrics[2] ? toNumber(row[3]) : undefined;
        return {
          name: row[0] != null ? `${row[0]}` : `点${idx + 1}`,
          value:
            size !== undefined ? [x, y, size, row[0]] : [x, y, row[0]],
        };
      });
    } else {
      data = rows.map((row, idx) => {
        const x = dimToNumber(row[0], idx);
        const y = toNumber(row[1]);
        return {
          name: row[0] != null ? `${row[0]}` : `点${idx + 1}`,
          value: [x, y, row[0]],
        };
      });
    }

    return {
      scatterData: data,
      hasBubbleSize: metrics.length >= 3,
    };
  }, [dData, metric_fields]);

  // 坐标轴名称
  const xAxisName =
    (metric_fields || []).length >= 2
      ? metric_fields[0]?.name || ""
      : dim_field?.name || "";
  const yAxisName =
    (metric_fields || []).length >= 2
      ? metric_fields[1]?.name || ""
      : metric_fields?.[0]?.name || "";
  const xAxisUnit =
    (metric_fields || []).length >= 2 ? metric_fields[0]?.unit || "" : "";
  const yAxisUnit =
    (metric_fields || []).length >= 2
      ? metric_fields[1]?.unit || ""
      : metric_fields?.[0]?.unit || "";

  const seriesName =
    (metric_fields || []).map((m) => m.name).join(" / ") || "散点";

  const getOptions = () => {
    return {
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          // value: [x, y, (size), dimName]
          const arr = params.value;
          const dimName = arr[arr.length - 1];
          const x = arr[0];
          const y = arr[1];
          let result = `${dimName}<br/>`;
          result += `${xAxisName}: ${Number(x).toLocaleString()}${xAxisUnit}<br/>`;
          result += `${yAxisName}: ${Number(y).toLocaleString()}${yAxisUnit}`;
          return result;
        },
      },
      grid: {
        left: 30,
        right: 30,
        bottom: "8%",
        top: 60,
        containLabel: true,
      },
      xAxis: {
        type: "value",
        name: xAxisName,
        nameLocation: "middle",
        nameGap: 30,
        nameTextStyle: {
          color: "#888",
          fontSize: 12,
        },
        axisLabel: {
          formatter: `{value}${xAxisUnit}`,
        },
        scale: true,
      },
      yAxis: {
        type: "value",
        name: yAxisName,
        nameLocation: "middle",
        nameGap: 40,
        nameTextStyle: {
          color: "#888",
          fontSize: 12,
        },
        axisLabel: {
          formatter: `{value}${yAxisUnit}`,
        },
        scale: true,
      },
      series: [
        {
          name: seriesName,
          type: "scatter",
          data: scatterData,
          symbolSize: hasBubbleSize
            ? function (data) {
                const size = data[2];
                return typeof size === "number" && size > 0
                  ? Math.max(8, Math.min(60, Math.sqrt(size) * 1.5))
                  : 12;
              }
            : 12,
          itemStyle: {
            color: "#2094ff",
            opacity: 0.85,
            borderColor: "#fff",
            borderWidth: 1,
          },
          emphasis: {
            focus: "series",
            scale: 1.4,
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(32, 148, 255, 0.5)",
            },
          },
        },
      ],
      legend: {
        data: [seriesName],
        top: 10,
      },
    };
  };

  return (
    <ReactEcharts
      style={{
        minHeight: "225px",
        maxHeight: "300px",
        width: "100%",
      }}
      option={getOptions()}
      notMerge={true}
      lazyUpdate={true}
    />
  );
}

export default ScatterData;
